// TaxList.jsx
import React, { useState, useEffect } from "react";
import TaxTable from "./Components/TaxTable";
import AddTax from "./Components/AddTax";
import EditTax from "./Components/EditTax";
import Swal from "sweetalert2";
import api from "../../../../../api/axios";
import BackButton from "../BackButton";

const TaxList = () => {
  const [taxes, setTaxes] = useState([]);
  const [loading, setLoading] = useState(true);

  const [isAddOpen, setIsAddOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [selectedTax, setSelectedTax] = useState(null);

  const fetchTaxes = async () => {
    setLoading(true);
    try {
      const res = await api.get("/pms/taxes");
      setTaxes(res.data.data || res.data || []);
    } catch (error) {
      console.error("Failed to fetch taxes:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTaxes();
  }, []);

  const handleDelete = async (id) => {
    const confirm = await Swal.fire({
      title: "Delete Tax?",
      text: "This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#6c757d",
      confirmButtonText: "Delete",
    });

    if (!confirm.isConfirmed) return;

    try {
      await api.delete(`/pms/taxes/${id}`);
      Swal.fire({ icon: "success", title: "Deleted", timer: 1200, showConfirmButton: false });
      fetchTaxes();
    } catch (error) {
      Swal.fire({ icon: "error", title: "Delete failed", text: error.response?.data?.message });
    }
  };

  const openEdit = (tax) => {
    setSelectedTax(tax);
    setIsEditOpen(true);
  };

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-3 page-body">
      <div className="d-flex align-items-center justify-content-between">
        <BackButton />
        <h3 className="fw-bold">Tax List</h3>
        <button className="btn btn-dark" onClick={() => setIsAddOpen(true)}>
          Add Tax
        </button>
      </div>

      <div className="card mt-3">
        <div className="card-body">
          <TaxTable data={taxes} loading={loading} onEdit={openEdit} onDelete={handleDelete} />
        </div>
      </div>

      <AddTax open={isAddOpen} onClose={() => setIsAddOpen(false)} onAdded={fetchTaxes} />
      <EditTax open={isEditOpen} onClose={() => setIsEditOpen(false)} tax={selectedTax} onUpdated={fetchTaxes} />
    </div>
  );
};

export default TaxList;
